import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useTranslation } from "react-i18next";

export const CopyRight = () => {
    const { t } = useTranslation();

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger
                asChild
                className="cursor-pointer px-4 py-2 font-normal text-base hover:bg-black hover:text-white"
            >
                <span>©</span>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
                <DropdownMenu.Content
                    className="min-w-[220px] rounded-t-md bg-black w-[400px]
                        shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)]
                        will-change-[opacity,transform] 
                        data-[side=top]:animate-slideDownAndFade
                    "
                    sideOffset={1}
                    side="top"
                >
                    <DropdownMenu.Item
                        className="p-4 text-[#c7c7c7] font-normal text-base
                        focus-visble:border-none
                        focus-visible:outline-none"
                    >
                        {t("Footer.copyRight", {
                            year: new Date().getFullYear(),
                        })}
                    </DropdownMenu.Item>
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    );
};
